<template>
    <div >
        <div class="panel panel-success" >

            <!-- Default panel contents -->
            <div class="panel-heading">
                <i class="fa fa-bars" aria-hidden="true"></i> MENU CLIENTE
            </div>
            <div class="panel-body" v-if="user.level < 5 && !user.permissoes.cacontrol" >
                <p>
                    <a :href="'#/cliente'" class="btn btn-info btn-block">
                        <i class="fa fa-plus-circle" aria-hidden="true"></i> NOVO CLIENTE
                    </a>
                </p>
            </div>

            <ul class="list-group" v-if="cliente && cliente._id">

                <li class="list-group-item" >
                    <a :href="'#/cliente/' + cliente._id">EDITAR DADOS</a>
                </li>

                <li class="list-group-item" >
                    <a :href="'#/cliente/contratos/' + cliente._id">CONTRATOS</a>
                </li>

            </ul>

        </div>

    </div>
</template>
<script>
export default {
    props: {
        cliente: null
    },
    data() {
        return {
            user: null
        };
    },
    beforeMount() {
        this.user = this.$store.state.user;
    }
};
</script>
